import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-card"},[_c(VCard,{staticClass:"mx-auto",attrs:{"color":"grey lighten-4","width":"320px"}},[_c(VImg,{attrs:{"aspect-ratio":8/9,"src":_vm.img,"alt":_vm.title}}),_c('h5',{staticClass:"center bold no-link px-1"},[_vm._v(_vm._s(_vm.title))]),_c('h5',{staticClass:"center no-link px-1"},[_vm._v(_vm._s(_vm.ocupation))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }